import React, { useState } from 'react'
import AddNewMajorEvents from './AddNewMajorEvents';

const MajorEvents = ({ data: majorEventsData, setIsRecordSaved, patientID, ...props}) => {
  
  let { isViewAllowed, IsEditAllowed , IsDeleteAllowed} = props;
  const [isOpenMajorEvents, setIsOpenMajorEvents] = useState(false);
  const [majorEventData, setMajorEventData] = useState();
  const [expandItems, setExpandItems] = useState(true);

  const handleToggleExpand = () => {
    setExpandItems(prev => !prev);
  }

  const AddMajorEvents = (item) => {
    if(!isViewAllowed) return;
    setMajorEventData(item)
    setIsOpenMajorEvents(prev => !prev);
  }
  const CloseMajorEvents = () => {
    setIsOpenMajorEvents(false)
  }

  let PopupScreen = "";
  if (isOpenMajorEvents) {
    PopupScreen = <AddNewMajorEvents isOpenMajorEvents={isOpenMajorEvents} majorEventData={majorEventData} setMajorEventData={setMajorEventData} setIsRecordSaved={setIsRecordSaved} onClose={CloseMajorEvents} patientID={patientID} // onDeleteMajorEvents={DeleteMajorEvents} 
    IsEditAllowed={IsEditAllowed} IsDeleteAllowed={IsDeleteAllowed}
    />
  }
  return (
    <>
      {PopupScreen}
      <div className='mb-2'>
        <div className="d-flex justify-content-between align-items-center mb-1 mx-2">
          <p className='heading cursor-pointer user-select-none' onClick={handleToggleExpand}>Major Events</p>
          <div className={`ar-add-icon ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddMajorEvents({ PatientHistoryID: null })}>
            <i className="icon-dash-plus"></i>
          </div>
        </div>
        <div className="d-flex flex-column gap-1 problem-scroll px-2">
          {expandItems &&
          (majorEventsData?.length > 0 ?
            majorEventsData.map(item => (
              <div className='ar-dot'>
              <p className={`multiline-ellipsis  text ar-hover-text validation_message ${isViewAllowed ? '' : 'disable'}`} onClick={() => AddMajorEvents(item)}>{item.Notes}</p>
              </div>
            )) :
            <p className="text C9-light-clr fst-italic">No major events recorded</p>)}
        </div>
      </div>
    </>
  )
}

export default MajorEvents